module.exports = __webpack_public_path__ + "img/history_timeline_3.2d9b5493.png";